<div class="container">
  <mic-breadcrumb id="preferred-treads-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('setupText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link
      link="/home/productData/preferred-treads"
      label="{{ translationService.translate('preferredTreadsText') }}"
    ></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('preferredTreadsSetupText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <h2 class="page-title preferred-treads-setup-heading" id="casing-size-heading">
    {{ translationService.translate('preferredTreadsSetupText') }}
  </h2>

  <mat-card class="search-card mt-3">
    <form [formGroup]="filterForm">
      <div class="w-full flex flex-row items-center justify-between search-filter-row">
        <div class="filter-fields">
          <mat-form-field subscriptSizing="dynamic" class="filter-field">
            <mat-label>{{ translationService.translate('codeText') }}</mat-label>
            <input matInput type="text" formControlName="code" placeholder="{{ translationService.translate('defaultText') }}" />
          </mat-form-field>
          <mat-form-field subscriptSizing="dynamic" class="filter-field">
            <mat-label>{{ translationService.translate('descriptionText') }}</mat-label>
            <input matInput type="text" formControlName="description" placeholder="{{ translationService.translate('defaultText') }}" />
          </mat-form-field>
        </div>
        <div class="action-buttons">
          <span
            [matTooltip]="
              productSaveDisabled
                ? this.translationService.translate('comingSoonText')
                : !saveEnabled
                ? this.translationService.translate('userCannotSaveText')
                : !isModified
                ? this.translationService.translate('noModifiedText')
                : null
            "
            matTooltipPosition="above"
          >
            <button
              id="save"
              class="btn-primary"
              type="button"
              mat-flat-button
              color="primary"
              (click)="save()"
              [disabled]="!saveEnabled || !isModified"
            >
              <mat-icon>save</mat-icon>
              {{ translationService.translate('saveLinkText') }}
            </button>
          </span>
          <button id="add" class="btn-primary" type="button" mat-flat-button color="primary" (click)="addTread()">
            <mat-icon>add</mat-icon>
            {{ translationService.translate('addNewText') }}
          </button>
        </div>
      </div>
    </form>
  </mat-card>

  <div id="finished-product-table" class="cam-table table-container">
    <mic-table #paginatedTable class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
      <ng-container *micTableNoData>
        <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'make'">
        <mic-dropdown-search
          micDropdownAccessibility
          emptyPlaceholder="No data found"
          subscriptSizing="dynamic"
          [virtualScroll]="true"
          [data]="makeList"
          [widthConfig]="{ width: '100%' }"
          [formControl]="getControl(item, 'casingMake')"
        ></mic-dropdown-search>
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'size'">
        <mic-dropdown-search
          micDropdownAccessibility
          emptyPlaceholder="No data found"
          subscriptSizing="dynamic"
          [virtualScroll]="true"
          [widthConfig]="{ width: '100%' }"
          [data]="casingSizeList"
          [formControl]="getControl(item, 'casingSize')"
        ></mic-dropdown-search>
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'application'">
        <mic-dropdown-search
          micDropdownAccessibility
          emptyPlaceholder="No data found"
          subscriptSizing="dynamic"
          [virtualScroll]="true"
          [widthConfig]="{ width: '100%' }"
          [data]="applicationList"
          [formControl]="getControl(item, 'application')"
        ></mic-dropdown-search>
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'axle'">
        <mic-dropdown-search
          micDropdownAccessibility
          emptyPlaceholder="No data found"
          subscriptSizing="dynamic"
          [virtualScroll]="true"
          [data]="axleList"
          [widthConfig]="{ width: '100%' }"
          [formControl]="getControl(item, 'axle')"
        ></mic-dropdown-search>
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'treadDesc'">
        <mic-dropdown-search
          micDropdownAccessibility
          emptyPlaceholder="No data found"
          subscriptSizing="dynamic"
          [virtualScroll]="true"
          [widthConfig]="{ width: '100%' }"
          [data]="preferredTreadSpecificationList"
          [formControl]="getControl(item, 'treadDesc')"
        ></mic-dropdown-search>
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'preferredTreadRank'">
        <mic-dropdown-search
          micDropdownAccessibility
          emptyPlaceholder="No data found"
          subscriptSizing="dynamic"
          [virtualScroll]="true"
          [widthConfig]="{ width: '100%' }"
          [data]="rankList"
          [formControl]="getControl(item, 'preferredTreadRank')"
        ></mic-dropdown-search>
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'action'">
        <div class="centered-cell">
          <button mat-icon-button class="btn-delete" [disabled]="this.productSaveDisabled" (click)="showDeleteModal(item)">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </div>
      </ng-container>
    </mic-table>
  </div>
  <mic-modal class="modalC" #deleteConfirmation (result)="onDeleteModalClosed($event)"></mic-modal>
  <ng-template #deleteContent>Are you sure you want to delete the Preferred Tread?</ng-template>
  <mic-modal class="modalC" #discardConfirmation (result)="onDiscardModalClosed($event)"></mic-modal>
  <ng-template #discardContent>{{ translationService.translate('unSaveChangesText') }}</ng-template>
</div>
